module.exports = __webpack_public_path__ + "img/feather-sprite.8bf209bf.svg";